import React from 'react';
export const ProductIntroSection = () => {
  const bullets = ['Sistema completo por nivel y edad', 'Actividades en inglés + guía en español', 'Mock tests reales con grilla de corrección', 'Adaptado a Cambridge Starters, KET y PET'];
  return <section className="bg-familia-bg py-10 md:py-16 px-4 md:px-6" data-id="element-181">
      <div className="max-w-5xl mx-auto text-center w-[92%] md:w-full" data-id="element-182">
        <div className="inline-block bg-familia-cyan text-familia-bg font-bold text-xs sm:text-sm px-4 sm:px-6 py-2 rounded-full mb-6 md:mb-8 uppercase tracking-wider" data-id="element-183">
          📚 El Sistema Cambridge Más Completo para Familias Argentinas
        </div>

        <h2 className="text-4xl sm:text-6xl md:text-7xl font-display font-bold mb-2" data-id="element-184">
          ENGLISH EN FAMILIA™
        </h2>
        <h3 className="text-[22px] sm:text-2xl md:text-3xl font-display font-bold text-familia-cyan mb-6 md:mb-8 uppercase tracking-widest" data-id="element-185">
          MEGA PACK BILINGÜE
        </h3>

        <p className="text-familia-gray text-[15px] md:text-xl max-w-3xl mx-auto mb-8 md:mb-12 leading-relaxed" data-id="element-186">
          3 Módulos + 3 Bonos —{' '}
          <span className="text-white font-bold" data-id="element-187">Inglés para el alumno.</span>{' '}
          <span className="text-familia-gold font-bold" data-id="element-188">
            Español para la familia.
          </span>
        </p>

        <div className="bg-familia-card border border-familia-cyan/15 p-6 md:p-12 rounded-3xl mb-10 md:mb-16" data-id="element-189">
          <p className="text-familia-gray text-[15px] md:text-lg mb-8 md:mb-12 leading-relaxed" data-id="element-190">
            <span className="text-white font-bold" data-id="element-191">+500 páginas</span> · 3
            módulos completos · 3 bonos · Young Learners · Teens Bridge ·
            Grammar Guide · Sistema Espejo · Mock Tests · Flashcards Bilingües ·
            Speaking Cards · Planificación Express · Guía de padres en cada
            página.
            <br data-id="element-192" />
            <span className="text-familia-cyan font-bold" data-id="element-193">
              Funciona desde hoy. Para cualquier nivel Cambridge en Argentina.
            </span>
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-left max-w-3xl mx-auto" data-id="element-194">
            {bullets.map((b, i) => <div key={i} className="flex items-center gap-3" data-id="element-195">
                <span className="text-familia-green text-xl" data-id="element-196">✅</span>
                <span className="font-bold text-[15px] sm:text-base" data-id="element-197">{b}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};